import { useOutletContext, useParams } from "react-router-dom";

import { db } from "astrid-firebase";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import LoadingContext from "../../ui/components/LoadingContext/LoadingContext";

import ContractorView from "../views/ContractorView/ContractorView";

export default function Contractor() {
	const { organization } = useOutletContext();
	const params = useParams();

	const [contractor, loading, error] = useDocumentData(db.collection("contractors").doc(params.contractorId));

	return (
		<LoadingContext data={contractor} loading={loading} error={error}>
			<ContractorView contractor={contractor} organization={organization} />
		</LoadingContext>
	);
}
